export default __webpack_public_path__ + "static/media/Vector-1.e5a02d77.png";